import { render, staticRenderFns } from "./weightSelect.vue?vue&type=template&id=1c1db249"
import script from "./weightSelect.vue?vue&type=script&lang=js"
export * from "./weightSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports